export enum Weekday {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export interface IOperatingHourModel {
  id: number;
  branchId: number;
  weekday: Weekday;
  open_time: string;
  close_time: string;
  coreId?: number;
  deletedAt?: Date | null;
}

